export default {
  tableClass: 'table card-table table-vcenter text-nowrap datatable',
  loadingClass: 'loading',
  ascendingIcon: 'feather-chevron-up',
  descendingIcon: 'feather-chevron-down',
  handleIcon: 'feather-menu',
  pagination: {
    infoClass: 'm-0 text-muted',
    wrapperClass: 'pagination m-0 ml-auto',
    activeClass: 'active',
    disabledClass: 'disabled',
    pageClass: 'page-link',
    linkClass: 'page-link',
    icons: {
      first: 'feather-chevrons-left',
      prev: 'feather-chevron-left',
      next: 'feather-chevron-right',
      last: 'feather-chevrons-right',
    },
  },
}